import React, { Component } from 'react';
import '../../../styles/scss/style.css';

//Components
import TextHeadingOne from '../atoms/TextHeadingTwo';
import TextParagraph from '../atoms/TextParagraph';
import TextAnchor from '../atoms/TextAnchor';
import FormButton from '../atoms/FormButton';
import LabeledTextfield from '../molecules/LabeledTextfield';
import logoImage from '../../../images/logo_text_bubble.svg';
import Image from '../atoms/Image';

//Returning the component
class FormLogin extends Component {
	render() {
		return (

			<div className="login">
				<div className="login__container">
				<a href="/"><Image alt="Frankie Logo" classType="login__logo" src={logoImage} /></a>
					<form onSubmit={this.props.handleFormSubmit} className={`form login__form ${this.props.formWrapperClassType}`}>
						<TextHeadingOne text={this.props.textHeadingOne} />
						<TextParagraph text={this.props.textParagraph} />

						{/* Email */}
						<LabeledTextfield
							formGroupClassType={this.props.formGroupClassType}
							labelFor={this.props.email} labelText={this.props.email}
							labelId={this.props.email}
							textfieldClassType={this.props.textfieldClassType}
							textfieldId={this.props.email}
							textfieldPlaceholder={this.props.email}
							textfieldName='emailInput'
							value={this.props.emailInput}
							textfieldForm={this.props.textFieldForm}
							onChange={this.props.emailOnChange}
							onBlur={this.props.onBlur}
							errorMessageClassType={this.props.errorMessageClassType}
							errorMessageText={this.props.errorMessageEmail}
							required={true}
						/>

						{/* Password */}
						<LabeledTextfield
							formGroupClassType={this.props.formGroupClassType}
							labelFor={this.props.password}
							labelText={this.props.password}
							inputType='password'
							labelId={this.props.password}
							textfieldClassType={this.props.textfieldClassType}
							textfieldId={this.props.password}
							textfieldPlaceholder={this.props.password}
							textfieldName='passwordInput'
							value={this.props.passwordInput}
							textfieldForm={this.props.textFieldForm}
							onChange={this.props.passwordOnChange}
							onBlur={this.props.onBlur}
							errorMessageClassType={this.props.errorMessageClassType}
							errorMessageText={this.props.errorMessagePassword}
							required={true}
						/>

						<TextAnchor text={this.props.forgotPassword} href={this.props.href} classType="login__forgotPassword" />

						<FormButton text={this.props.formButtonText} classType={this.props.formButtonClassType} />

						<div dangerouslySetInnerHTML={{ __html: `<p class="login__noAccount textParagraph">${this.props.noAccount}</p>` }} />
					</form>
				</div>
			</div>
		)
	}
}

export default FormLogin;


// WEBPACK FOOTER //
// ./src/redux/components/organisms/FormLogin.jsx